import AddProjectModalContainer from './containers/AddProjectModalContainer'

export default AddProjectModalContainer
